export default __webpack_public_path__ + "static/media/thereef-logo.258bfb6e.png";